import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { LoadingSpaceType } from '../../../../core/types';

@Component({
    selector: 'gl-air-container-preview',
    templateUrl: './air-container-preview.component.html',
    styleUrls: ['./air-container-preview.component.scss'],
    standalone: false
})
export class AirContainerPreviewComponent implements OnChanges {
  @Input() loadingSpace: LoadingSpaceType;
  public isTypeX = false;
  public isTypeY = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.loadingSpace && changes.loadingSpace.currentValue) {
      this.isTypeX = changes.loadingSpace.currentValue.airType === 1;
      this.isTypeY = changes.loadingSpace.currentValue.airType === 2;
    }
  }
}
